// extracted by mini-css-extract-plugin
export default {"container":"cookies_container__KO1wF","content":"cookies_content__NRzUa","text":"cookies_text__-5USM","policy":"cookies_policy__RxFsS","button":"cookies_button__fBe8V"};